// Copyright (c) 2016 Deere & Company

import ClaimHistory from '@deere/cps-it.warranty-model-factory/lib/claim-history';
import t from 'tcomb';

const Report = t.list(ClaimHistory, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/claim-history/state/report.js